import type {ChartType} from './types';

export default {
	chartData: (type: ChartType) => `/charts/${type}`,
};
